import { NaiveStaticPartVersionSerde } from "./NaiveStaticPartVersionSerde";
/**
 * A static part version repository is much simpler than a regular part version repository, because it does not need
 * to support modifying the existing version data.  It can only read/write/check existence.
 */
export class StaticPartVersionRepository {
    storageAdapter;
    serde;
    constructor(storageAdapter, serde = new NaiveStaticPartVersionSerde()) {
        this.storageAdapter = storageAdapter;
        this.serde = serde;
    }
    /**
     * Get a static part version object.
     */
    async get(descriptor) {
        const schemaTag = descriptor.schemaTag ?? this.serde.serializationSchemaTag;
        // TODO: can we avoid this copy?
        return this.storageAdapter.get({ schemaTag, ...descriptor }).then((rawPv) => {
            if (rawPv) {
                return this.fromStored(rawPv);
            }
            return undefined;
        });
    }
    /**
     * Save a part version object.
     * TODO: Technically the schemaTag should be defined by the serializer - we shouldn't need to pass it in here.
     */
    save(data) {
        return this.storageAdapter.save(this.intoStored(data));
    }
    /**
     * Check to see if a static part version object exists that satisfies the reference.
     */
    exists(descriptor) {
        const schemaTag = descriptor.schemaTag ?? this.serde.serializationSchemaTag;
        return this.storageAdapter.exists({ schemaTag, ...descriptor });
    }
    /**
     * Convert a raw part version data into its stored representation.
     */
    intoStored(data) {
        return this.serde.intoStored(data);
    }
    /**
     * Convert a stored static part version data object back into its non-stored representation.
     */
    fromStored(data) {
        return this.serde.fromStored(data);
    }
}
//# sourceMappingURL=StaticPartVersionRepository.js.map